import delve from 'dlv'
import type { FC } from 'react'
import { useTranslation } from 'next-i18next'
import parse from 'html-react-parser'
import { getBlock } from 'lib/model'

interface Props {
  content: any
}

const PolicyPage: FC<Props> = ({ content }) => {
  const { t } = useTranslation()
  const { updatedAt } = delve(content, 'data.attributes')
  const block = getBlock(
    delve(content, 'data.attributes.blocks'),
    'blocks.policy'
  )
  const { title, text } = block

  return (
    <section className="hero-section">
      <div className="container policy-container">
        <div className="policy-wrapper">
          <div className="policy-title">
            <h1>{title}</h1>
          </div>
          {parse(text)}
          <p className="text">
            {t('legal.policy.lastUpdated', {
              date: new Date(updatedAt),
            })}
          </p>
        </div>
      </div>
    </section>
  )
}

export default PolicyPage
